export const bodyFont = () => `'Inter var', sans-serif`;
